import React, { useEffect, useState } from 'react';

import ContactsSpinner from '../components/ContactsSpinner';
import { useContactsContext } from '../contexts/ContactsContext';
import { ContentContainer } from '../components/styled';
import VirtualScroller, { VirtualScrollerSettings } from '../components/VirtualScroller';

function Contacts() {
  const contactsContext = useContactsContext();
  const [errorLoadingContacts] = useState<string | undefined>(undefined);
  const [scrollerSettings, setScrollerSettings] = useState<VirtualScrollerSettings>();
  const ref = React.createRef<HTMLDivElement>();

  const contacts = contactsContext.contacts;

  useEffect(() => {
    const parentNode = ref?.current?.parentNode;
    if (!(parentNode instanceof Element)) {
      return;
    }

    const height = parentNode.getBoundingClientRect().height;

    const itemHeight = 60;

    const scrollerSettings = {
      amount: Math.ceil((height ?? 0) / itemHeight),
      itemHeight,
      minIndex: 0,
      maxIndex: contacts.length,
      startIndex: 0,
      tolerance: 25,
      data: contacts,
    };

    setScrollerSettings(scrollerSettings);
  }, [contacts]);

  return (
    <ContentContainer ref={ref}>
      {(!contacts || (contacts && contacts.length === 0)) && (
        <>
          {errorLoadingContacts ? <div>{errorLoadingContacts}</div> :
            <div className="mt-3"><ContactsSpinner/></div>}
        </>
      )}
      { scrollerSettings && <VirtualScroller settings={scrollerSettings}/> }
    </ContentContainer>
  );
}

export { Contacts };
